import React, { useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';


const options = {
    responsive: true,
    plugins: {
        tooltip: {
            enabled: true,
        },
        legend: {
            position: "bottom",
            textDirection: "rtl",
            reverse: true,
            rtl: true,
            labels: {
                boxWidth: 5,
                boxHeight: 5,
                padding: 52,
                usePointStyle: true,
                pointStyle: "circle",
                color: "#363636",
                font: {
                    size: 14,
                    family: "Vazir",
                    lineHeight: "20px",
                },
            },
            // onClick: (e) => e.native.stopPropagation(),
        },
        datalabels: {
            backgroundColor: "#FFFFFF",
            borderWidth: 1,
            borderColor: "#E3E3E3",
            borderRadius: 12,
            color: '#363636',
            align: "end",
            anchor: "start",
            offset: 10,
            textAlign: "center",
            padding: {
                top: 8,
                right: 18,
                bottom: 3,
                left: 18,
            },
            font: {
                size: 17,
                family: "Vazir",
                weight: '700',
                lineHeight: "28px",
            },
        },
    }
}


const DoughnutChart = ({ data }) => {
    const chartRef = useRef(null);
    Chart.register(ArcElement, Legend, ChartDataLabels, {
        id: "setSumTotal",
        beforeDraw: (chart) => {
            let width = chart.width,
                height = chart.height,
                ctx = chart.ctx;
            ctx.fillStyle = "#363636";
            ctx.font = "normal normal 700 40px/60px Vazir";
            let sumChart = chart.config.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
            );
            let text = sumChart,
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = (height / 2) - 15;
            ctx.fillText(text, textX, textY);
            ctx.save();
        }
    });

    return (
        <Doughnut data={data} ref={chartRef} options={options} width={380} height={380} />
    )
}

export default DoughnutChart;

